import * as React from "react";

import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
import { ReactNode } from "react";

const inputVariants = cva(
  "flex h-10 w-full bg-background px-3 py-2 text-sm text-primary ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "rounded-md border border-input bg-white shadow-sm ",
        ghost: "rounded-md",
        minimal: "border-b border-input focus-visible:rounded-md",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {
  icon?: ReactNode;
  iconPosition?: "left" | "right";
  containerClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      variant,
      icon,
      containerClassName,
      iconPosition = "left",
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn("relative", containerClassName)}>
        {icon && (
          <div
            className={`absolute inset-y-0 ${iconPosition === "left" ? "left-0 pl-3" : "right-0 pr-3"} pointer-events-none flex items-center`}
          >
            {icon}
          </div>
        )}
        <input
          type={type}
          ref={ref}
          className={cn(
            inputVariants({ variant, className }),
            icon && iconPosition === "left" ? "pl-10" : "",
            icon && iconPosition === "right" ? "pr-10" : ""
          )}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
